// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	editorials: [],
	single: {},
	edit: {},
	isFetching: false,
};

function editorialsReceived(state, payload) {
	state = setBusy(state, false);

	if (typeof payload === 'object' && payload.hasOwnProperty('editorials')) {
		return {...state, editorials: payload.editorials};
	}

	return state;
}

function editorialsTypeReceived(state, payload) {
	state = setBusy(state, false);

	if (typeof payload === 'object' && payload.hasOwnProperty('editorials')) {
		return {...state, error: false, editorialsByType: payload.editorials, firstEditorial: payload.firstEditorial, nextType: payload.next, prevType: payload.prev, total: payload.total, totalEditorials: payload.totalEditorials};
	}

	if (typeof payload === 'object' && payload.hasOwnProperty('error')) {
		return {...state, error: payload.error, nextType: null, prevType: null, total: 0};
	}

	return state;
}

function singleEditorialReceived(state, payload) {
	state = setBusy(state, false);
	if (typeof payload === 'object' && payload.hasOwnProperty('id') && payload.hasOwnProperty('typeId')) {
		if (!payload.hasOwnProperty('contents')) {
			payload.contents = [];
		}

		if (!payload.hasOwnProperty('sections')) {
			payload.sections = [];
		}

		return {...state, single: payload};
	}

	return state;
}

function editEditorialReceived(state, payload) {
	if (typeof payload === 'object') {
		return {
			...state,
			edit: payload,
		};
	}

	return state;
}

function setBusy(state, payload = true) {
	return {...state, isFetching: payload};
}

function reqSingleEditorial(state, payload = true) {
	state = setBusy(state, true);

	return {...state, single: {}};
}

export default function menuReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.EDITORIALS_RECV_DATA:
			return editorialsReceived(state, action.payload);
		case actionTypes.EDITORIALS_RECV_TYPE_DATA:
			return editorialsTypeReceived(state, action.payload);
		case actionTypes.EDITORIALS_RECV_SINGLE_DATA:
			return singleEditorialReceived(state, action.payload);
		case actionTypes.EDITORIALS_REQ_DATA:
			return setBusy(state, true);
		case actionTypes.EDITORIALS_REQ_SINGLE_DATA:
			return reqSingleEditorial(state);
		case actionTypes.EDITORIALS_RECV_ERROR:
			return setBusy(state, false);
		// Editorial creation
		case actionTypes.ACCOUNT_EDITORIAL_RECV_DATA:
			return editEditorialReceived(state, action.payload);
		case actionTypes.EDITORIALS_CLEAR_SINGLE:
			return { ...state, single: {} };
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/editorials.js
 **/